import React, { useEffect } from "react";

import image_section_1 from '../assets/images/MainPage/Home_Hero-2.png';

import homeIcon from "../assets/images/AboutUs/OurGoals/homeIcon.png";
import visibilityIcon from "../assets/images/AboutUs/OurGoals/360Degree.png";
import fundingIcon from "../assets/images/AboutUs/OurGoals/fundingIcon.png";
import communicationIcon from "../assets/images/AboutUs/OurGoals/communicationIcon.png";

import OurTeamCard from "../components/OurTeamCard";
import Rohit from "../assets/images/AboutUs/WhoAreWe/Rohit.jpg";
import Denise from "../assets/images/AboutUs/WhoAreWe/Denise.png";
import Nikita from "../assets/images/AboutUs/WhoAreWe/Nikita.jpg";
import Ricky from "../assets/images/AboutUs/WhoAreWe/Ricky.png";
import Sangeeta from "../assets/images/AboutUs/WhoAreWe/Sangeeta.png";

import fundsCameFrom from "../assets/images/AboutUs/OurFinances/where-our-funds-came-from.png"
import fundsWereUsed from "../assets/images/AboutUs/OurFinances/how-our-funds-were-used.png"


function AboutUs() {
    useEffect(() => {
        document.title = "About Us";
    }, []);
    return (
        <>
            {/* New Header Section for About Us */}
            <section>
                <div
                    className="w-full h-[66.7vh] bg-cover bg-center relative"
                    style={{ backgroundImage: `url(${image_section_1})` }}
                >
                    {/* Blue overlay with transparency */}
                    <div
                        className="absolute inset-0 bg-[#307694] opacity-90 mix-blend-overlay"
                    ></div>

                    {/* Content container with max w-7xl that match navbar/footer */}
                    <div className="max-w-7xl mx-auto px-4 h-full flex flex-col justify-center relative z-10">
                        <div className="md:pl-4 flex flex-col items-center md:items-start space-y-2">
                            {/* Title for About Us Page */}
                            <div>
                                <h1 className="font-roboto font-bold text-[42px] sm:text-[45px] md:text-[52px] lg:text-[60px] leading-none text-white">
                                    About Us
                                </h1>
                            </div>
                            <p className="font-roboto font-normal text-[24px] sm:text-[24px] md:text-[25px] lg:text-[25.45px] leading-[140%] text-white mb-4">
                                Our Mission, Vision, and Impact
                            </p>

                            {/* No button here unless you specifically need one for this page */}
                        </div>
                    </div>
                </div>
            </section>

            {/* The rest of your About Us content */}
            {/* WHO WE ARE Section */}
            <section className="bg-[#CFE6EF] text-[#1A1A1A] pt-16 pb-16">
                <div className="max-w-4xl mx-auto px-6 md:px-10 text-center">
                    <h2 className="text-4xl md:text-5xl font-bold mb-6">Who We Are</h2>
                    <p className="text-lg md:text-xl leading-relaxed">
                        Fund Homecare Canada is a Canadian registered charitable, non-for-profit organization dedicated to making in-home care accessible to palliative cancer patients—a critical and prevalent need that is unfortunately out of reach for many.
                        <br /><br />
                        We created Fund Homecare Canada to address this discrepancy by providing financial support to help cancer patients and their families with in-home palliative care needs. Our funding goes towards personal care, housekeeping services, meals, nursing, and shopping assistance.
                    </p>
                </div>
            </section>

            {/* OUR GOALS Section */}
            <section className="bg-[#54749D] text-white pt-16 pb-16">
                <div className="max-w-4xl mx-auto px-6 md:px-10">
                    <h2 className="text-4xl md:text-5xl font-bold mb-12 text-center">Our Goals</h2>

                    <div className="space-y-10">
                        {/* Goal 1 */}
                        <div className="flex flex-col sm:flex-row items-center sm:items-start text-center sm:text-left gap-4">
                            <img src={homeIcon} alt="home icon" className="w-14 h-14" />
                            <p className="text-lg md:text-xl leading-relaxed">
                                Funding <strong>home-based palliative care</strong> for cancer patients residing in Ontario.
                            </p>
                        </div>

                        {/* Goal 2 */}
                        <div className="flex flex-col sm:flex-row items-center sm:items-start text-center sm:text-left gap-4">
                            <img src={visibilityIcon} alt="360 visibility icon" className="w-14 h-14" />
                            <p className="text-lg md:text-xl leading-relaxed">
                                Maintain a 360 degree monitoring mechanism to <strong>provide visibility</strong> for our sponsors and clients.
                            </p>
                        </div>

                        {/* Goal 3 */}
                        <div className="flex flex-col sm:flex-row items-center sm:items-start text-center sm:text-left gap-4">
                            <img src={fundingIcon} alt="funding icon" className="w-14 h-14" />
                            <p className="text-lg md:text-xl leading-relaxed">
                                Channel funding specifically toward <strong>palliative cancer patients</strong> who do not qualify for government or any other funding for home-based care.
                            </p>
                        </div>

                        {/* Goal 4 */}
                        <div className="flex flex-col sm:flex-row items-center sm:items-start text-center sm:text-left gap-4">
                            <img src={communicationIcon} alt="communication icon" className="w-14 h-14" />
                            <p className="text-lg md:text-xl leading-relaxed">
                                Utilize <strong>communication channels</strong> including direct outreach, social media campaigns, and fundraising events to encourage corporate giving, crowdfunding, and personal donations.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Meet Our Team Section */}
            <div className="bg-[#307694] py-12 md:py-20 w-full">
                <div className="w-full px-4 sm:px-6 mx-auto">
                    <h2 className="text-white font-bold text-3xl sm:text-4xl md:text-5xl mb-8 md:mb-12 text-center" style={{ fontFamily: 'Montserrat' }}>
                        Meet Our Team
                    </h2>

                    {/* Enhanced grid with better responsive behavior */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8 w-full">
                        <OurTeamCard
                            name="Rohit Bhalla"
                            role="Co-Founder"
                            image={Rohit}
                            bio="Rohit Bhalla is the Co-Founder of Fund Homecare Canada. Known for his innovative problem solving, Rohit's passion for a better tomorrow drove him to address one of the most prominent gaps in healthcare: access to home-based palliative care. With guidance from respected connections in the industry, Rohit's vision to support palliative cancer patients in need of care came to fruition and Fund Homecare was born.

                            Rohit has over 30 years of experience in strategic client engagement and portfolio management roles, and holds a degree in business administration and multiple certifications in leadership and management. Having lived and worked in Canada, India, Dubai, and the US, Rohit brings a wealth of international experience and a vast network of connections to his work at Fund Homecare"
                        />

                        <OurTeamCard
                            name="Denise D'Silva"
                            role="Co-Founder"
                            image={Denise}
                            bio="Helping people in need is in Denise's blood, especially those that are not able to help themselves for a variety of reasons. Denise's drive to help start Fund Homecare was accelerated by the discovery that many people in her community are low income and cannot afford external resources to help them care for their loved ones when it matters most.

                            Denise is a licensed Paralegal and has worked in the non-for-profit industry for over 15 years. She has vast experience in dealing with government organizations, the healthcare industry, and community agencies."
                        />

                        <OurTeamCard
                            name="Nikita Sahni"
                            role="Volunteer Board Member"
                            image={Nikita}
                            bio="Nikita is a Director at Fund Homecare. Her heart for volunteering with Habitat for Humanity, Youth Without Shelter, the YMCA Youth Council, and new immigrants encouraged her to work with Fund HomeCare to bring real solutions to real problems experienced by Canadians.

                            As a Queen's MBA graduate, Nikita was heavily involved in the campus community. She was a director in her Student Executive Council, and was involved with Engineers Without Borders and the Women in Engineering club during her undergraduate degree. Now, Nikita is working as a product owner, working to utilize technology to enhance the industry."
                        />

                        <OurTeamCard
                            name="Ricky Pinto"
                            role="Volunteer Board Member"
                            image={Ricky}
                            bio="In the last 10-15 years, a number of Ricky's friends and family were diagnosed with cancer, and he witnessed first hand struggles to make palliative care arrangements. He joined the Fund Homecare team in the hopes of contributing his knowledge and expertise to the cause.

                            Ricky is a Canadian CPA, CA and has significant experience serving a range of entities, primarily in the financial services sector, in Canada, England and the Middle East. Prior to his retirement in 2017, he was a Deloitte audit partner. He has been involved in various leadership and governance roles over the years. Most recently, he has served on the board of a Mississauga regional community clinic, an Ontario pension advisory committee, and a Toronto charity bike ride committee."
                        />

                        <OurTeamCard
                            name="Sangeeta Madan"
                            role="Treasurer"
                            image={Sangeeta}
                            bio="Sangeeta is a voluntary board member and the Treasurer of Fund Homecare. Her desire to help anyone in need, makes her a perfect addition to the team at Fund Homecare. Sangeeta moved to Canada in 2022 with an accounting designation from India and the US. She has been working with Royal Bank of Canada for the past 21 years in various roles within finance and technology.

                            During this time she also completed her CPA, CA designation in Canada. Sangeeta is currently a Senior Director, Supplier Management Office for the Technology and Operations within Royal Bank of Canada responsible for the risk and relationship management for ~1000 technology vendors."
                        />
                    </div>
                </div>
            </div>
            {/* Our Finances Section */}
            <section className="bg-white text-[#1A1A1A] py-12 md:py-20">
                <div className="max-w-7xl mx-auto px-6 md:px-10">
                    <h2 className="text-4xl md:text-5xl font-bold mb-8 text-center" style={{ fontFamily: 'Montserrat' }}>
                        Our Finances
                    </h2>

                    <div className="mb-12">
                        <p className="text-lg md:text-xl leading-relaxed mb-4">
                            Fund Homecare Canada is a volunteer driven organization with no administrative overheads and little operating expenses. This model allows us to maximize funds raised to be used for our goals – <strong>Helping In-home Palliative Cancer patients in Ontario get support and services they need in their time of need.</strong>
                        </p>
                        <p className="text-lg md:text-xl leading-relaxed mb-4">
                            Fund Homecare Canada raises funds through Corporate Sponsorships, Individual donations and via events. Our fund-raising programs are carefully planned for generating funds, raising awareness and growing our network base. All net proceeds from our fund-raising activities after operating expenses, are directly used towards providing services for our beneficiaries.
                        </p>
                        <p className="text-lg md:text-xl leading-relaxed mb-4">
                            In 2022, over 90% of generated funds went towards helping our beneficiaries.
                        </p>
                        <p className="text-lg md:text-xl leading-relaxed">
                            Since our setup in 2021, Fund Homecare Canada has supported 11 beneficiaries (as of Dec 2023).
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
                        <div className="flex justify-center">
                            <img src={fundsCameFrom} alt="Where our funds came from (2022)" className="w-full max-w-md h-auto" />
                        </div>
                        <div className="flex justify-center">
                            <img src={fundsWereUsed} alt="How our funds were used (2022)" className="w-full max-w-md h-auto" />
                        </div>
                    </div>

                    <div>
                        <h3 className="text-3xl md:text-4xl font-bold mb-6 text-center" style={{ fontFamily: 'Montserrat' }}>
                            Financial Statements
                        </h3>
                        <p className="text-lg md:text-xl leading-relaxed mb-4 text-center">
                            Fund Homecare Canada has a commitment and goal of being fully transparent. Keeping that in mind, we make our financial statements, costs and how funds raised are used, totally transparent. Please find our financial statements <a href="https://apps.cra-arc.gc.ca/ebci/hacc/srch/pub/dsplyQckVw?selectedCharityBn=779061142RR0001&isSingleResult=false&q.stts=0007" target="_blank" rel="noopener noreferrer" className="text-[#307694] hover:underline font-semibold">here</a>.
                        </p>
                    </div>
                </div>
            </section>
        </>
    );
}

export default AboutUs;